import '../styles/ShowHome.css';

import { withNavigation }      from 'components/App/withNavigation';
import { WithNavigationProps } from 'components/App/withNavigation';
import React                   from 'react';
import { Card }                from 'antd';
import { Col }                 from 'antd';
import Row                     from 'components/App/Row';
import { Link }                from 'react-router-dom';
import { observer }            from 'mobx-react';
import { ApiCollection }       from 'collections/ApiCollection';
import currentSession          from 'utils/currentSession';
import FormattedMessageWrapper from 'components/App/FormattedMessageWrapper';
import StandModel              from 'models/StandModel';
import ShowModel               from 'models/ShowModel';

import defaultLogoUrl from '/images/default-logo.png?url';

interface ShowHomeState {
  loaded: boolean;
}

@observer
class ShowHome extends React.Component<WithNavigationProps> {
  public showCollection = new ApiCollection(ShowModel);

  public state: ShowHomeState = {
    loaded: false, // stop display before possible redirection
  };

  public componentDidMount = async () => {
    this.showCollection.setFilter('order[createdAt]', 'desc');
    this.showCollection.setFilter('enabled', true);

    try {
      await this.showCollection.list();

      if (!currentSession.isAdminOrSupport && this.showCollection.total === 1) {
        const show = this.showCollection.first();

        const standCollection = new ApiCollection(StandModel);
        standCollection.setFilter('show', show?.id);
        await standCollection.list();

        if (standCollection.total === 1) {
          const stand = standCollection.first();
          this.props.navigate(`/stands/${stand?.id}`);
        } else {
          this.props.navigate(`/salons/${show?.id}/stands`);
        }
      }
    } catch {
      this.props.navigate('/erreur');
    } finally {
      this.setState({ loaded: true });
    }

    return null;
  };

  render() {
    return (
      <Row>
        <Col>
          <div style={{ paddingTop: 16 }}>
            <div style={{ display: 'flex', flexWrap: 'wrap' }}>
              {(this.showCollection.isLoaded && this.showCollection.total === 0) && (
                <p>
                  <FormattedMessageWrapper id="Aucun salon." />
                </p>
              )}

              {this.state.loaded &&
                this.showCollection.map((show: ShowModel) => (
                  <div className="home-show-link accented-shadow" key={show.id}>
                    <Link key={show.get('id')} to={`/salons/${show.id}`}>
                      <Card className="show-card">
                        <div className="home-show-container">
                          <div className="home-show-logo-container">
                            <img
                              alt="logo"
                              src={show.logoObjectUrl || defaultLogoUrl}
                            />
                          </div>
                          <h3>
                            {show.showName.substring(0, 27)}{show.showName.length > 30 && '...'}
                          </h3>
                        </div>
                      </Card>
                    </Link>
                  </div>
                ))}
            </div>
          </div>
        </Col>
      </Row>
    );
  }
}

const ShowHomeWithNavigation = withNavigation(ShowHome);

export default ShowHomeWithNavigation;
